import { render, staticRenderFns } from "./discount.vue?vue&type=template&id=2ed5aeec"
import script from "./discount.vue?vue&type=script&lang=js"
export * from "./discount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ed5aeec')) {
      api.createRecord('2ed5aeec', component.options)
    } else {
      api.reload('2ed5aeec', component.options)
    }
    module.hot.accept("./discount.vue?vue&type=template&id=2ed5aeec", function () {
      api.rerender('2ed5aeec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/discount.vue"
export default component.exports